import { httpService } from 'src/services';
import { crosstableWithoutApi } from 'src/constants';

export function getProject(token: string = '', id : string|number) {
  return httpService.get(`${crosstableWithoutApi}${id}`, {}, {
    Authorization: `Bearer ${token}`,
  });
}
